import * as React from 'react';

import { useSession, USER_ROLES } from '~/contexts/session';

import { AgencyLayout } from '../AgencyLayout';
import { BrandLayout } from '../BrandLayout';

interface LayoutProps {
  children: React.ReactNode;
}

export default function DashboardLayout({ children }: LayoutProps) {
  const { role } = useSession();
  switch (role) {
    case USER_ROLES.agency:
      return <AgencyLayout>{children}</AgencyLayout>;
    case USER_ROLES.brandUser:
    case USER_ROLES.brand:
      return <BrandLayout>{children}</BrandLayout>;
    case USER_ROLES.creatorEcho:
    case USER_ROLES.talentRep:
      return <>{children}</>;
    default:
      return <></>;
  }
}
